import { render } from "./Paroisse.vue?vue&type=template&id=2c9563ba&scoped=true"
import script from "./Paroisse.vue?vue&type=script&lang=js"
export * from "./Paroisse.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=2c9563ba&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9563ba"]])

export default __exports__